<template>
<div class="content-wrapper">
  <!-- <crumbs :trail="'系统设置'" :subTrail="` > ${operateType}`" :href="'http://baidu.com'"></crumbs> -->
  <div class="bigBox">
    <p class="label-weight-one">广告算法设置</p>
    <div class="topContent">
      <div class="form-item">
        <label class="label">算法开启状态:</label>
        <div class="ad-set-switch">
          <el-switch v-model="switchValue" inactive-color="#ccc" active-color="#5798d7"></el-switch>
        </div>
      </div>
      <div class="form-item exposure-time-item">
        <label class="label">累计曝光值 <el-popover placement="right" title="" width="220" trigger="hover" content="广告策略在广告位上累计达到的广告曝光总量，达到该值进入算法。">
            <span slot="reference" class="iconfont el-icon-third-49"></span>
          </el-popover> :</label>
        <el-input placeholder="请输入大于0的整数" v-model="inputexposure"></el-input>
        <span class="exposure-icon">次</span>
      </div>
      <div class="form-item exposure-time-item">
        <label class="label">查询数据时间
            <el-popover placement="right" title="" width="220" trigger="hover" content="广告算法启动时往前追溯的时间范围值。"><span slot="reference" class="iconfont el-icon-third-49"></span></el-popover> :
          </label>
        <el-input placeholder="0000" v-model="inputtime"></el-input>
        <span class="time-icon">小时</span>
      </div>
      <p class="label-weight-one-two">素材算法设置</p>
      <div class="form-item exposure-time-item">
        <label class="label">新素材累计曝光值 <el-popover placement="right" title="" width="220" trigger="hover" content="新素材累计曝光达到该值，自动加入算法。">
            <span slot="reference" class="iconfont el-icon-third-49"></span>
          </el-popover> :</label>
        <el-input placeholder="请输入大于0的整数" v-model="MaterialExposureCount"></el-input>
        <span class="exposure-icon">次</span>
      </div>
      <div class="form-item exposure-time-item">
        <label class="label">素材查询数据时间
            <el-popover placement="right" title="" width="220" trigger="hover" content="查询素材往前追溯的时间范围值。"><span slot="reference" class="iconfont el-icon-third-49"></span></el-popover> :
          </label>
        <el-input placeholder="0000" v-model="MaterialQueryDataTime"></el-input>
        <span class="time-icon">小时</span>
      </div>
      <div class="form-item exposure-time-item">
        <label class="label">新素材累计曝光概率 <el-popover placement="right" title="" width="220" trigger="hover" content="新上素材曝光未达到100的，按照设置的曝光概率进行曝光">
            <span slot="reference" class="iconfont el-icon-third-49"></span>
          </el-popover> :</label>
        <el-input placeholder="请输入大于0的整数" v-model="MaterialExposureProbability"></el-input>
        <span class="exposure-icon">%</span>
      </div>

    </div>
    <div class="label-box">
      <p class="label-weight-two">计划权重值设置</p>
      <label class="selectSwitch">计划开启状态</label>
      <template>
          <el-select v-model="value" placeholder="请选择" class="selectStatus">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      <label class="selectSwitch">计划ID/名称</label>
      <el-input placeholder="计划ID/名称" class="projectinput" clearable v-model="projectId"></el-input>
      <el-button type="primary" @click="search" class="searchBtn">搜索</el-button>
    </div>
    <div class="bottomContent">
      <div class="industry">
        <div class="industry-item-row" v-for="item in transData" :key="item.LabelId">
          <div class="industry-item">
            <label class="label" :title="item.AdTaskName">{{item.LabelName}}</label>
            <el-input placeholder="权重值" class="industry-input" v-model="item.Weight"></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="btn">
    <el-button type="primary" @click="saveData" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
  </div>
</div>
</template>

<script>
import crumbs from "../public/crumbs/crumbs";
// api
import {
  saveData,
  initData
} from 'api/adSetting'

export default {
  data() {
    return {
      operateType: "广告算法设置",
      switchValue: true, //开关状态
      allData: {},
      fullscreenLoading: false, //loading
      inputexposure: "", //累计曝光值
      inputtime: "", //查询数据时间
      MaterialExposureCount: "", //素材累计曝光值
      MaterialExposureProbability: "", //素材累计曝光概率
      MaterialQueryDataTime: "", //素材查询数据时间
      transData: [],
      categoryData: [],
      postData: [],
      options: [{
        value: '-1',
        label: '全部'
      }, {
        value: '0',
        label: '已开启'
      }, {
        value: '1',
        label: '未开启'
      }],
      value: '', //计划开启状态
      projectId: "", //计划id
    };
  },
  created() {
    this.value = "0";
    initData({
      PutOnIdOrName: "",
      Status: 0
    }).then(res => {
      this.allData = res;
      this.allData.AlgorithmOnState == 0 ? this.switchValue = false : this.switchValue = true; //算法开启状态
      this.inputexposure = this.allData.CumulativeExposureCount; //累计曝光值
      this.inputtime = this.allData.QueryDataTime; //查询数据时间
      this.MaterialExposureCount = this.allData.MaterialExposureCount; //素材累计曝光值
      this.MaterialExposureProbability = this.allData.MaterialExposureProbability; //素材累计曝光概率
      this.MaterialQueryDataTime = this.allData.MaterialQueryDataTime; //素材查询数据时间
      this.transData = this.allData.PutOnData; //标签权重设置项、内容
      for (var i = 0; i < this.transData.length; i++) {
        this.transData[i].Weight = this.transData[i].Weight.toFixed(2);
        this.transData[i].LabelName = this.transData[i].PutOnId + "(" + this.transData[i].AdTaskName + ")";
      }
    })
  },
  methods: {
    //搜索
    search() {
      //计划开启状态
      var Status = this.value;
      //计划id
      let PutOnIdOrName = this.projectId || "";
      initData({
        PutOnIdOrName: PutOnIdOrName,
        Status: Status
      }).then(res => {
        if (res.status == 101) {
          this.$message({
            showClose: true,
            message: '查询失败',
            type: 'error'
          });
        } else {
          this.allData = res;
          this.transData = this.allData.PutOnData; //标签权重设置项、内容
          for (var i = 0; i < this.transData.length; i++) {
            this.transData[i].Weight = this.transData[i].Weight.toFixed(2);
            this.transData[i].LabelName = this.transData[i].PutOnId + "(" + this.transData[i].AdTaskName + ")";
          }
        }
      })
    },
    saveData() {
      if (this.inputexposure == "" || this.inputtime == "" || this.MaterialExposureCount == "" || this.MaterialQueryDataTime == "" || this.MaterialExposureProbability == "") {
        this.$alert('算法设置项不可为空，请输入后再保存', '提示', {
          confirmButtonText: '确定'
        })
        return;
      } else if ((!/^[0-9]*[1-9][0-9]*$/.test(this.inputexposure)) || (!/^[0-9]*[1-9][0-9]*$/.test(this.inputtime)) || (!/^[0-9]*[1-9][0-9]*$/.test(this.MaterialExposureCount)) || (!/^[0-9]*[1-9][0-9]*$/.test(this.MaterialQueryDataTime)) || (!
          /^[0-9]*[1-9][0-9]*$/.test(this.MaterialExposureProbability))) {
        this.$alert('输入有误，请输入大于0的整数', '提示', {
          confirmButtonText: '确定'
        })
        return;
      }
      let overData = this.transData;
      for (var i = 0; i < overData.length; i++) {
        if (overData[i].Weight == "") {
          this.$alert("*" + overData[i].LabelName + "*" + '标签权重值不可为空，请输入后再保存', '提示', {
            confirmButtonText: '确定'
          })
          return;
        } else if (overData[i].Weight > 2 || overData[i].Weight <= 0) {
          this.$alert("*" + overData[i].LabelName + "*" + '标签输入有误，输入值范围：0<权重值≤2', '提示', {
            confirmButtonText: '确定'
          })
          return;
        } else {
          this.postData[i] = {
            "PutOnId": overData[i].PutOnId.toString(),
            "Weight": overData[i].Weight.toString()
          }
        }
      }
      let postallData = JSON.stringify(this.postData)
      this.switchValue == true ? this.switchValue = 1 : this.switchValue = 0;
      this.$confirm('此操作将保存数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true;
        saveData({
          AlgorithmOnState: this.switchValue.toString(), //算法开启状态
          CumulativeExposureCount: this.inputexposure.toString(), //累计曝光值
          QueryDataTime: this.inputtime.toString(), //查询数据时间
          MaterialExposureCount: this.MaterialExposureCount.toString(), //素材累计曝光值
          MaterialExposureProbability: this.MaterialExposureProbability.toString(), //素材累计曝光概率
          MaterialQueryDataTime: this.MaterialQueryDataTime.toString(), //素材查询数据时间
          putondata: postallData,
        }).then(res => {
          setTimeout(() => {
            if (res.remark) {
              this.$router.go(0)
              this.fullscreenLoading = false;
            }
          }, 400)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消保存'
        });
      });

    }
  },
  components: {
    crumbs
  }
}
</script>

<style lang="scss" scoped>
@import "~common/scss/color.scss";
@import "../../assets/icon/iconfont.css";
#bigBox {
    width: 1310px;
    margin: 0 auto;
}
.topContent {
    width: 95%;
    height: 350px;
    margin-left: 50px;
    border-bottom: 1px dashed $borderColor;
}
.form-item {
    width: 390px;
    margin-top: 14px;
    overflow: auto;
    .label {
        float: left;
        width: 160px;
        line-height: 36px;
        margin-right: 10px !important;
        font-size: 14px;
        color: rgba(31,31,31,0.49);
        font-weight: bold;
        text-align: right;
    }
    .ad-set-switch {
        position: relative;
        float: left;
        height: 34px;
        width: 220px;
        .el-switch {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            margin: auto 0;
        }
    }
    .el-input,
    .el-input__inner {
        width: 173px;
        height: 34px;
        border-right: none;
    }
    &.exposure-time-item {
        position: relative;
        .exposure-icon,
        .time-icon {
            position: absolute;
            right: 0;
            top: 0;
            width: 50px;
            height: 34px;
            line-height: 34px;
            border: 1px solid $borderColor;
            border-left: none;
            font-size: 12px;
            color: #666;
            text-align: center;
            box-sizing: border-box;
        }
    }
}
.label-weight-one {
    height: 40px;
    line-height: 40px;
    margin: 10px 50px;
    padding-left: 20px;
    font-size: 16px;
    font-weight: 700;
    color: rgba(31,31,31,1);
    font-weight: bold;
    font-style: normal;
    background: rgba(78, 192, 229, 0.1);
}
.label-weight-one-two {
    height: 40px;
    line-height: 40px;
    margin: 10px 0;
    padding-left: 20px;
    font-size: 16px;
    font-weight: 700;
    color: rgba(31,31,31,1);
    font-weight: bold;
    font-style: normal;
    background: rgba(78, 192, 229, 0.1);
}
.label-box {
    background: rgba(78, 192, 229, 0.1);
    width: 95%;
    margin: 10px 50px;
}
.label-weight-two {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-right: 50px;
    padding-left: 20px;
    font-size: 16px;
    color: rgba(31,31,31,0.65);
    font-weight: bold;
    font-style: normal;
}
.selectSwitch {
    display: inline-block;
    width: 100px;
    font-size: 16px;
    color: rgba(31,31,31,0.65);
    font-style: normal;
}
.selectStatus {
    margin-right: 30px;
}
.projectinput {
    width: 200px;
}
.searchBtn {
    width: 140px;
    height: 40px;
    margin-left: 50px;
}
.bottomContent {
    width: 98%;
    height: auto;
    margin-left: 50px;
    position: relative;
    .label-industry {
        width: 65px;
        height: 24px;
        font-size: 16px;
        line-height: 24px;
        margin-left: 30px;
        font-weight: 600;
        color: rgba(31,31,31,0.65);
        font-weight: bold;
        font-style: normal;
    }
    .industry {
        width: 98%;
        height: auto;
        margin: 0 auto;
        overflow: hidden;
        .industry-item-row {
            float: left;
            width: 25%;
            margin: 15px 0;
            .industry-item {
                position: relative;
                width: 250px;
                height: 34px;
                margin: 0 auto;
                .label {
                    display: block;
                    max-width: 12em;
                    height: 34px;
                    padding-right: 4px;
                    line-height: 34px;
                    font-size: 14px;
                    color: rgba(168, 168, 168,0.97);
                    font-weight: normal;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    text-align: left;
                    overflow: hidden;
                }
                .el-input,
                .el-input__inner {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 76px;
                    height: 34px;
                }
                .industry-input .el-input__inner {
                    text-align: center;
                }
            }
        }
    }
}
#btn {
    width: 120px;
    height: 100px;
    margin: 40px auto;
}
.message-pop {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 100px;
    background: #fac;
    .top {
        float: left;
        width: 200px;
        height: 20px;
        background: rgb(78, 192, 229);
        .tit {
            float: left;
            width: 40px;
            height: 20px;
        }
        .closex {
            float: right;
            width: 20px;
            height: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ad-setting/ad-setting.vue